import type { EFakturaCreditor } from '../../../generated-types';

const mapTextsFromIssuers = (issuers?: EFakturaCreditor[], allText = '') =>
    issuers
        ? {
              textOne: issuers[0]?.name,
              textTwo: issuers[1]?.name,
              textThree: issuers[2]?.name,
          }
        : { textOne: allText };

export default mapTextsFromIssuers;
